import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { AutoAwesome as AIIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyMealPlansProps = {
  onGenerateMealPlan: (() => void) | null;
  upgradePrompt?: React.ReactNode;
};

const EmptyMealPlans = ({ onGenerateMealPlan, upgradePrompt }: EmptyMealPlansProps) => {
  const events = useEvents();

  return (
    <Box data-testid="EmptyMealPlansView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Create comprehensive weekly meal plans for your clients! Generate AI-powered meal plans with new recipes or use your existing recipe collection."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Generate meal plans with AI using macro targets and dietary preferences.
            The AI will create new recipes for you, or you can select from your existing
            recipe collection if you have any.
          </Typography>

          {upgradePrompt ? (
            upgradePrompt
          ) : onGenerateMealPlan ? (
            <StandardButton
              data-testid="EmptyMealPlansView-Button"
              variant="primary"
              startIcon={<AIIcon />}
              onClick={() => {
                onGenerateMealPlan();
                events.logButtonClick({
                  buttonName: "Generate Your First Meal Plan",
                  pageName: "Nutrition",
                  tabName: "Meal Plans",
                });
              }}
              style={{ fontSize: 16 }}
            >
              Generate Your First Meal Plan
            </StandardButton>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyMealPlans;
